import React, { Component, Fragment } from 'react';
import { Row, Col, Input, Form, FormGroup, Table, Label } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons'
import Progress from '../ProgressBar/Progress';
import 'bootstrap/dist/css/bootstrap.css';

class WorkflowManagement extends Component {
    constructor(props) {
        super(props);
        this.selectorArr = this.props.selector != null && this.props.selector !== '' ? this.props.selector.split('/') : [];

        this.todayLocal = String(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 1000 * 60)).toISOString()).substring(0, 10);

        this.state = {
            data: [],
            // departments: [],
            teams: [],
            employees: [],
            sheetData: [],
            show: "workflows",
            startDate: this.selectorArr.length > 0 && this.selectorArr[0] != null && this.selectorArr[0] !== 'today' ? (this.selectorArr[0]) : this.todayLocal,
            endDate: this.selectorArr.length > 1 && this.selectorArr[1] != null && this.selectorArr[1] !== 'today' ? (this.selectorArr[1]) : this.todayLocal,
            selectedTeam: this.selectorArr.length > 3 && this.selectorArr[3] != null ? parseInt(this.selectorArr[3]) : 0,
            selectedClient: this.selectorArr.length > 4 && this.selectorArr[4] != null ? parseInt(this.selectorArr[4]) : 0,
            selectedEmployee: this.selectorArr.length > 5 && this.selectorArr[5] != null ? parseInt(this.selectorArr[5]) : 0,
            selectedWorkflowDuration: this.selectorArr.length > 6 && this.selectorArr[6] != null ? parseInt(this.selectorArr[6]) : 24,
            selectedSortColumnIndex: -1,
            selectedSortAscending: true,
            highlightLate: true,
            highlightNotCompleted: true,
            deliveryTimeFrom: '',
            deliveryTimeUntil: '',
            quickView: true,
            morningProcesses: true,
            isLoading: null,
            isSilent: false,
            autoReload: this.selectorArr.length > 2 && this.selectorArr[2] != null && !isNaN(parseInt(this.selectorArr[2])) ? parseInt(this.selectorArr[2]) : 60,
            autoReloadTime: null
        };
        this.columns = [
            { name: 'Department(s)', sort: 'departments' },
            { name: 'Team', sort: 'alpha', key: 'team', quickView: 1 },
            { name: 'Client', sort: 'alpha', key: 'client', quickView: 1 },
            { name: 'Workflow Name', sort: 'alpha', key: 'workflowName', quickView: 1 },
            { name: 'Workflow Description', sort: 'alpha', key: 'workflowDescription', className: 'wrap' },
            { name: 'Workflow Task', sort: 'alpha', key: 'workflowStep', quickView: 1 },
            { name: 'Workflow Task Description', sort: 'alpha', key: 'workflowStepDescription', className: 'wrap' },
            { name: 'Employee', sort: 'alpha', key: 'lastName', quickView: 1 },
            { name: 'Date', sort: 'date', key: 'date', quickView: 24 },
            { name: 'Complete', sort: 'boolean', key: 'isComplete', quickView: 1 },
            { name: 'BD Completed', sort: 'numeric', key: 'bdCompleted' },
            { name: 'BD Due', sort: 'date', key: 'bdDue', quickView: 730 },
            { name: 'SLA BD Status', sort: 'numeric', key: 'bdLate' },
            { name: 'Target Start Time', sort: 'time', key: 'estimatedBeginTime' },
            { name: 'Deliverable Time', sort: 'time', key: 'deliverableTime', quickView: 24 },
            { name: 'Target Duration', sort: 'numeric', key: 'targetDuration' },
            { name: 'Actual Start Time (EST)', sort: 'actualStartTime', quickView: 1 },
            { name: 'Actual End Time (EST)', sort: 'actualEndTime', quickView: 1 },
            { name: 'Actual Duration', sort: false },
            { name: 'Total Task Duration', sort: 'numeric', key: 'totalActualDuration' },
            { name: 'Performance (%)', sort: 'numeric', key: 'totalDurationDifference' },
            { name: 'User Notes', sort: 'notes', quickView: 1 }
        ].map((column, index) => {
            return { ...column, index: index }
        })
        this.interval = null;
    }

    componentDidMount() {
        this.props.log('WorkflowManagement.js/componentDidMount');
        this.getEmployees();
        this.getTeams();
        this.onSubmit();
        if (this.state.autoReload > 0) {
            this.interval = setInterval(this.onSubmit, this.state.autoReload * 1000, true);
        }
    }

    onChangeSelector = () => {
        this.props.log('WorkflowManagement.js/onChangeSelector');
        console.log(this.state.startDate, this.state.endDate, this.todayLocal)
        this.props.changeSelector({
            target: {
                value: String(
                    ((this.state.startDate === this.state.endDate && this.state.startDate === this.todayLocal) ? 'today' : this.state.startDate) + '/' +
                    ((this.state.startDate === this.state.endDate && this.state.startDate === this.todayLocal) ? 'today' : this.state.endDate) + '/' +
                    (this.state.autoReload) + '/' +
                    (this.state.selectedTeam) + '/' +
                    (this.state.selectedClient) + '/' +
                    (this.state.selectedEmployee) + '/' +
                    (this.state.selectedWorkflowDuration)
                ).replace('/0/0/0/0/0', '')
            }
        })
    }

    onAutoReload = (val) => {
        this.props.log('WorkflowManagement.js/onAutoReload (val)', val);
        this.setState({
            autoReload: val,
        }, () => {
            if (this.interval != null) clearInterval(this.interval);
            if (val > 0) {
                this.interval = setInterval(this.onSubmit, val * 1000, true);
                this.onSubmit(true);
            } else {
                clearInterval(this.interval);
                this.setState({
                    autoReloadTime: null
                })
            }
            this.onChangeSelector();
        })
    }

    onSubmit = (silent = false) => {
        this.props.log('WorkflowManagement.js/onSubmit (silent)', silent);
        this.setState({
            isLoading: true,
            isSilent: silent,
            autoReloadTime: this.state.autoReload > 0 ? new Date().getTime() + (this.state.autoReload * 1000) : null
        }, () => {

            fetch('/api/reports/WorkflowManagement2', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken
                },
                body: JSON.stringify([
                    { key: 'startDate', type: 'date', value: this.state.startDate },
                    { key: 'endDate', type: 'date', value: this.state.endDate },
                    { key: 'teamId', type: 'int', value: parseInt(this.state.selectedTeam) > 0 ? parseInt(this.state.selectedTeam) : null },
                    { key: 'clientId', type: 'int', value: parseInt(this.state.selectedClient) > 0 ? parseInt(this.state.selectedClient) : null },
                    { key: 'employeeId', type: 'int', value: parseInt(this.state.selectedEmployee) > 0 ? parseInt(this.state.selectedEmployee) : null },
                    { key: 'workflowDuration', type: 'int', value: parseInt(this.state.selectedWorkflowDuration) > 0 ? parseInt(this.state.selectedWorkflowDuration) : null }
                ])
            })
                .then(results => results.json())
                .then(results => {
                    if (results.success) {
                        let data = results.data[0];
                        let fullList = results.data[1];
                        // console.log('data', data);
                        // console.log('fullList', fullList)
                        let mergeArray = [];
                        fullList
                            .filter(client => client.employeeId === this.state.selectedEmployee || this.state.selectedEmployee === 0)
                            .filter(client => client.workflows != null).forEach(client => {
                            client.workflows.forEach(workflow => {
                                mergeArray.push({
                                    estimatedBeginTime: null,
                                    bdCompleted: null,
                                    bdDue: null,
                                    bdLate: null,
                                    client: client.name,
                                    clientId: client.clientId,
                                    deliverableTime: workflow.estimates != null && workflow.estimates.length > 0 ? workflow.estimates[0].estimatedEndTime : null,
                                    departments: client.departments != null ? JSON.stringify(client.departments) : null,
                                    employeePrimaryContact: client.employeePrimaryContact,
                                    firstName: null,
                                    isComplete: false,
                                    lastName: null,
                                    targetDuration: workflow.estimates != null && workflow.estimates.length > 0 ? workflow.estimates[0].estimatedDuration : null,
                                    team: client.team,
                                    times: null,
                                    totalActualDuration: null,
                                    totalDurationDifference: null,
                                    workflowDescription: workflow.workflowDescription,
                                    workflowDuration: workflow.workflowDuration,
                                    workflowId: workflow.workflowId,
                                    workflowName: workflow.workflowName,
                                    workflowMorningProcess: workflow.morningProcess,
                                    workflowStep: null,
                                    workflowStepDescription: null,
                                    workflowStepId: null,
                                    workflowStepMorningProcess: false
                                })
                            })
                            client.workflows.filter(workflow => workflow.workflowTasks != null).forEach(workflow => {
                                workflow.workflowTasks.forEach(workflowTask => {
                                    mergeArray.push({
                                        estimatedBeginTime: null,
                                        bdCompleted: null,
                                        bdDue: null,
                                        bdLate: null,
                                        client: client.name,
                                        clientId: client.clientId,
                                        deliverableTime: workflow.estimates != null && workflow.estimates.length > 0 ? workflow.estimates[0].estimatedEndTime : null,
                                        departments: client.departments != null ? JSON.stringify(client.departments) : null,
                                        employeePrimaryContact: client.employeePrimaryContact,
                                        firstName: null,
                                        isComplete: false,
                                        lastName: null,
                                        targetDuration: workflow.estimates != null && workflow.estimates.length > 0 ? workflow.estimates[0].estimatedDuration : null,
                                        team: client.team,
                                        times: null,
                                        totalActualDuration: null,
                                        totalDurationDifference: null,
                                        workflowDescription: workflow.workflowDescription,
                                        workflowDuration: workflow.workflowDuration,
                                        workflowId: workflow.workflowId,
                                        workflowName: workflow.workflowName,
                                        workflowMorningProcess: workflow.morningProcess,
                                        workflowStep: workflowTask.name,
                                        workflowStepDescription: workflowTask.workflowTaskName,
                                        workflowStepId: workflowTask.workflowTaskId,
                                        workflowStepMorningProcess: workflowTask.morningProcess
                                    })
                                })
                            })
                        })
                        // console.log('mergeArray', mergeArray)
                        const allDates = [...new Set([...data].map(item => item.date))].sort()
                        // console.log(allDates);
                        // loop through each date
                        allDates.forEach(date => {
                            // loop through each mergeArray
                            mergeArray.filter(i => i.workflowStepId == null).forEach(item => {
                                // if clientID and workflowID aren't match (workflowStepId null) then add with the current date
                                if (data.findIndex(d => d.clientId === item.clientId && d.workflowId === item.workflowId && d.workflowTaskId == null) === -1) {
                                    data.push({ ...item, date: date })
                                }
                            })
                            mergeArray.filter(i => i.workflowStepId != null).forEach(item => {
                                // if clientID and workflowID and workflowStepId aren't match then add with the current date
                                if (data.findIndex(d => d.clientId === item.clientId && d.workflowId === item.workflowId && d.workflowTaskId === item.workflowTaskId) === -1) {
                                    data.push({ ...item, date: date })
                                }
                            })
                        })
                        data = data.sort((a,b) => a.workflowName.localeCompare(b.workflowName));
                        data = data.sort((a,b) => a.client.localeCompare(b.client));
                        data = data.sort((a,b) => a.date.localeCompare(b.date));
                        // console.log('newData', data)
                        this.setState({
                            data: this.processData(data),
                            isLoading: false,
                            isSilent: false
                        }, () => this.getCSVdata());
                    } else {
                        this.setState({
                            isLoading: false,
                            isSilent: false
                        })
                        this.props.addToast('Unable to download report.', 5, 'danger');
                    }
                })
            .catch(() => {
                this.setState({
                    isLoading: false,
                    isSilent: false
                })
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
        })
    }

    getTeams = () => {
        this.props.log('WorkflowManagement.js/getTeams');
        fetch('/api/teams/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        teams: results.data
                    });
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getEmployees = () => {
        this.props.log('WorkflowManagement.js/getEmployees');
        fetch('/api/employees/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (this.isUnmounted) return;
                if (results.success) {
                    this.setState({
                        employees: results.data.sort((a, b) => a.lastName.localeCompare(b.lastName))
                    });
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    processData = (data) => {
        this.props.log('WorkflowManagement.js/processData (data)', data);
        data = data.map(item => {
            return {
                ...item,
                actualStartTime: this.getTime(item.actualStartTime),
                actualEndTime: this.getTime(item.actualEndTime),
                totalActualDuration: item.totalActualDuration != null ? item.totalActualDuration : '',
                departments: item.departments != null ? (typeof (item.departments) === 'object' ? item.departments : JSON.parse(item.departments)) : null,
                times: item.times != null ? (typeof (item.times) === 'object' ? item.times : JSON.parse(item.times)) : null,
            }
        })
        return data;
    }

    formatDate = (d) => {
        if (parseInt(String(d).substring(0, 4)) <= 2000) return "";
        return parseInt(String(d).substring(5, 7)) + '/' + parseInt(String(d).substring(8, 10)) + '/' + parseInt(String(d).substring(0, 4));
    }

    getTime = (time) => {
        if (time == null || time === '') return '';
        var hours = parseInt(time.substring(0, 2)),
            minutes = parseInt(time.substring(3, 5)),
            ampm = 'am';
        if (hours === 12) {
            ampm = 'pm';
        } else if (hours === 0) {
            hours = 12;
        } else if (hours > 12) {
            hours -= 12;
            ampm = 'pm';
        }
        return hours + ':' + String(minutes).padStart(2, '0') + ' ' + ampm;
    }

    onChange = (e, submit) => {
        this.props.log('WorkflowManagement.js/onChange (name, value, e, submit)', e.target.name, e.target.value, e, submit);
        e.persist();
        this.setState(() => {
            switch (e.target.type) {
                case "checkbox":
                    return { [e.target.name]: !this.state[e.target.name] }
                default:
                    return { [e.target.name]: (e.target.value) }
            }
        }, () => {
            if (this.interval != null) clearInterval(this.interval);
            if (this.state.autoReload > 0) this.interval = setInterval(this.onSubmit, this.state.autoReload * 1000, true)
            this.onChangeSelector();
            this.getCSVdata();
            if (submit) this.onSubmit();
        }
        );
    }

    handleSort = (colIndex) => {
        this.props.log('WorkflowManagement.js/handleSort (colIndex)', colIndex, this.columns[colIndex].sort);
        if (!this.columns[colIndex].sort) return;
        this.setState((prevState) => {
            const ascending = (colIndex === prevState.selectedSortColumnIndex) ? !prevState.selectedSortAscending : true;
            return {
                selectedSortColumnIndex: colIndex,
                selectedSortAscending: ascending,
                data: [...prevState.data].sort((a, b) => {
                    const a2 = (this.columns[colIndex].key != null && a[this.columns[colIndex].key] != null) ? a[this.columns[colIndex].key] : '';
                    const b2 = (this.columns[colIndex].key != null && b[this.columns[colIndex].key] != null) ? b[this.columns[colIndex].key] : '';
                    switch (this.columns[colIndex].sort) {
                        case "date":
                            return ascending ? (new Date(a[this.columns[colIndex].key]).getTime()) - (new Date(b[this.columns[colIndex].key]).getTime())
                                : (new Date(b[this.columns[colIndex].key]).getTime()) - (new Date(a[this.columns[colIndex].key]).getTime());
                        case "numeric":
                            return ascending ? a[this.columns[colIndex].key] - b[this.columns[colIndex].key]
                                : b[this.columns[colIndex].key] - a[this.columns[colIndex].key];
                        case "boolean":
                            return ascending ? a[this.columns[colIndex].key] - b[this.columns[colIndex].key]
                                : b[this.columns[colIndex].key] - a[this.columns[colIndex].key];
                        case "departments":
                            return ascending ? (a.departments != null ? a.departments.map(d => { return d.departmentName != null ? d.departmentName : '' }).join(',') : '')
                                .localeCompare((b.departments != null ? b.departments.map(d => { return d.departmentName != null ? d.departmentName : '' }).join(',') : ''))
                                : (b.departments != null ? b.departments.map(d => { return d.departmentName != null ? d.departmentName : '' }).join(',') : '')
                                    .localeCompare((a.departments != null ? a.departments.map(d => { return d.departmentName != null ? d.departmentName : '' }).join(',') : ''));
                        case "actualStartTime":
                            const aS = a.times != null && a.times.map(d => d.actualStartTime).shift() ? a.times.map(d => d.actualStartTime).shift() : '';
                            const bS = b.times != null && b.times.map(d => d.actualStartTime).shift() ? b.times.map(d => d.actualStartTime).shift() : '';
                            return ascending ? aS.localeCompare(bS) : bS.localeCompare(aS);
                        case "actualEndTime":
                            const aE = a.times != null && a.times.map(d => d.actualEndTime).pop() != null ? a.times.map(d => d.actualEndTime).pop() : '';
                            const bE = b.times != null && b.times.map(d => d.actualEndTime).pop() != null ? b.times.map(d => d.actualEndTime).pop() : '';
                            return ascending ? aE.localeCompare(bE) : bE.localeCompare(aE);
                        case "notes":
                            const aN = a.times != null && a.times.map(d => d.notes).join(',') != null ? a.times.filter(d => d.notes != null && d.notes !== '').map(d => d.notes).join(',') : '';
                            const bN = b.times != null && b.times.map(d => d.notes).join(',') != null ? b.times.filter(d => d.notes != null && d.notes !== '').map(d => d.notes).join(',') : '';
                            return ascending ? aN.localeCompare(bN) : bN.localeCompare(aN);
                        case "actualDuration":
                            return ascending ? a.times.reduce((prev, cur) => (prev + cur.actualDuration), 0) - b.times.reduce((prev, cur) => (prev + cur.actualDuration), 0)
                                : b.times.reduce((prev, cur) => (prev + cur.actualDuration), 0) - a.times.reduce((prev, cur) => (prev + cur.actualDuration), 0);
                        default:
                            return ascending ? a2.localeCompare(b2) : b2.localeCompare(a2)
                    }
                })
            }
        })
    }

    getCSVdata = () => {
        this.props.log('WorkflowManagement.js/getCSVdata');
        let retArr = [[
            'Start Date: ',
            'End Date: ',
            'Client: ',
            'Employee: ',
            'Team: ',
        ],
        [
            this.formatDate(this.state.startDate),
            this.formatDate(this.state.endDate),
            document.getElementById('selectedClient').options[document.getElementById('selectedClient').selectedIndex].text,
            document.getElementById('selectedEmployee').options[document.getElementById('selectedEmployee').selectedIndex].text,
            document.getElementById('selectedTeam').options[document.getElementById('selectedTeam').selectedIndex].text,
        ],
        [], [...this.columns].map(column => column.name)];

        const filteredArray = [...this.state.data]
            .filter(row => (this.state.show === "both") || (this.state.show === 'workflows' && row.workflowStep == null) || (this.state.show === 'tasks' && row.workflowStep != null))
            .filter(row => (this.state.deliveryTimeFrom !== '') ? row.deliverableTime >= this.state.deliveryTimeFrom : row)
            .filter(row => (this.state.deliveryTimeUntil !== '') ? row.deliverableTime <= this.state.deliveryTimeUntil : row)
            .filter(row => (this.state.morningProcesses) ? (row.workflowMorningProcess || row.workflowStepMorningProcess) : row);
        const performance = (
            (
                (filteredArray.reduce(
                    (prev, next, index) => prev +
                        (next.targetDuration != null && !isNaN(next.targetDuration) && filteredArray[index].totalActualDuration !== "" ? Number(next.targetDuration) : 0)
                    , 0)) /
                (filteredArray.reduce(
                    (prev, next, index) => prev +
                        (next.totalActualDuration != null && next.totalActualDuration !== '' && !isNaN(next.totalActualDuration) && filteredArray[index].targetDuration != null ? Number(next.totalActualDuration) : 0)
                    , 0)
                )
            ) * 100
        ).toFixed(2);
        retArr = [retArr].concat(filteredArray
            .map(row => (
                row.times != null ? (row.times.filter((time, timeIndex) => timeIndex === 0).map(time => (
                    [
                        row.departments != null && row.departments !== '' ? (row.departments).map(item => item.departmentName).join(', ') : '',
                        row.team,
                        row.client,
                        row.workflowName != null ? row.workflowName : '',
                        row.workflowDescription != null ? row.workflowDescription : '',
                        row.workflowStep != null ? row.workflowStep : '',
                        row.workflowStepDescription != null ? row.workflowStepDescription : '',
                        row.lastName + ', ' + row.firstName,
                        this.formatDate(row.date),
                        row.isComplete ? 'Yes' : '',
                        row.bdCompleted !== 0 && row.bdCompleted != null ? row.bdCompleted : '',
                        row.bdDue !== 0 && row.bdDue != null ? row.bdDue : '',
                        row.bdLate !== 0 && row.bdLate != null ? 'Late' : '',
                        this.getTime(row.estimatedBeginTime),
                        row.deliverableTime != null ? this.getTime(row.deliverableTime) : '',
                        row.targetDuration != null ? row.targetDuration : '',
                        time.actualStartTimeAdjusted != null && time.actualStartTimeAdjusted !== time.actualStartTime ? this.getTime(time.actualStartTimeAdjusted) + ' (' + this.getTime(time.actualStartTime) + ' ' + time.timezone.replace(/[^A-Z]/g, '') + ')' : this.getTime(time.actualStartTime),
                        time.actualEndTimeAdjusted != null && time.actualEndTimeAdjusted !== time.actualEndTime ? this.getTime(time.actualEndTimeAdjusted) + ' (' + this.getTime(time.actualEndTime) + ' ' + time.timezone.replace(/[^A-Z]/g, '') + ')' : this.getTime(time.actualEndTime),
                        time.actualDuration,
                        row.totalActualDuration != null ? row.totalActualDuration : '',
                        row.totalDurationDifference !== 0 && row.totalDurationDifference != null ? row.totalDurationDifference : '',
                        time.notes != null ? time.notes : ''
                    ]
                )).concat(
                    row.times.filter((time, timeIndex) => timeIndex > 0).map((time, timeIndex) => (
                        [
                            '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
                            this.getTime(row.times[timeIndex].actualStartTime),
                            this.getTime(row.times[timeIndex].actualEndTime),
                            row.times[timeIndex].actualDuration,
                            '', '',
                            row.times[timeIndex].notes != null ? row.times[timeIndex].notes : '',
                        ]
                    ))
                )) : [[
                    '',
                    row.team,
                    row.client,
                    row.workflowName,
                    row.workflowDescription,
                    row.workflowStep,
                    row.workflowStepDescription,
                    row.employeePrimaryContact + '*',
                    this.formatDate(row.date),
                    row.isComplete ? "Yes" : "",
                    row.bdCompleted != null && !isNaN(row.bdCompleted) && row.bdCompleted > 0 && row.isComplete === 1 ? Number(row.bdCompleted) : '',
                    row.bdDue != null && !isNaN(row.bdDue) && row.bdDue > 0 ? Number(row.bdDue) : '',
                    row.bdLate != null && !isNaN(row.bdLate) && row.bdLate > 0 ? 'Late' : '',
                    '',
                    this.getTime(row.deliverableTime),
                    row.targetDuration != null ? row.targetDuration /*+ ' h'*/ : '',
                    '',
                    '',
                    '',
                    row.totalActualDuration != null && !isNaN(row.totalActualDuration) && Number(row.totalActualDuration) !== 0 ? Number(row.totalActualDuration) /*+ ' h' */ : '',
                    row.totalDurationDifference != null && !isNaN(row.totalDurationDifference) ? Number(row.totalDurationDifference) /*+ '%'*/ : '',
                    ''
                ]])
            )
        ).flat()
        retArr.push([]);
        retArr.push(
            ['', 'Total', '', '', '', '', '', '', '', '', '', '', '', '', '',
                Math.round(filteredArray.reduce((prev, next) => prev + next.targetDuration, 0) * 100) / 100,
                '', '', '',
                Math.round(filteredArray.reduce((prev, next) => prev + (next.totalActualDuration != null && !isNaN(next.totalActualDuration) ? Number(next.totalActualDuration) : 0), 0) * 100) / 100,
                !isNaN(performance) ? Math.round((performance) * 100) / 100 : '',
                ''
            ]
        );
        this.props.passData(retArr, "workflow-management");
    }

    isNull = (val, separator) => {
        return val != null ? separator + val : '';
    }

    isQuickView = (col) => {
        if (!this.state.quickView || (parseInt(this.state.selectedWorkflowDuration) === 0)) return ' ';
        return (
            this.columns[col].quickView === 1 ||
            (this.columns[col].quickView === 24 &&
                (parseInt(this.state.selectedWorkflowDuration) === 24)) ||
            (this.columns[col].quickView > 24 &&
                (parseInt(this.state.selectedWorkflowDuration) > 24))
        ) ? ' ' : 'd-none ';
    }

    render() {
        this.props.info('WorkflowManagement.js/render');
        const filteredArray = [...this.state.data]
            .filter(row => (this.state.show === "both") || (this.state.show === 'workflows' && row.workflowStep == null) || (this.state.show === 'tasks' && row.workflowStep != null))
            .filter(row => (this.state.deliveryTimeFrom !== '') ? row.deliverableTime >= this.state.deliveryTimeFrom : row)
            .filter(row => (this.state.deliveryTimeUntil !== '') ? row.deliverableTime <= this.state.deliveryTimeUntil : row)
            .filter(row => (this.state.morningProcesses) ? (row.workflowMorningProcess || row.workflowStepMorningProcess) : row);
        const performance = (
            (
                (filteredArray.reduce(
                    (prev, next, index) => prev +
                        (next.targetDuration != null && !isNaN(next.targetDuration) && filteredArray[index].totalActualDuration !== "" ? Number(next.targetDuration) : 0)
                    , 0)) /
                (filteredArray.reduce(
                    (prev, next, index) => prev +
                        (next.totalActualDuration != null && next.totalActualDuration !== '' && !isNaN(next.totalActualDuration) && filteredArray[index].targetDuration != null ? Number(next.totalActualDuration) : 0)
                    , 0)
                )
            ) * 100
        ).toFixed(2);
        return (
            <>
                <Row>
                    <Col>
                        <Row className="mt-4">
                            <Col>
                                <Form inline>
                                    <FormGroup className='mr-4 mb-2'>
                                        <Label>Start Date
                                            <Input className="ml-2" type="date"
                                                name="startDate"
                                                onChange={(e) => this.onChange(e, true)}
                                                value={this.props.isFieldNull(this.state.startDate)}
                                            /></Label>
                                    </FormGroup>
                                    <FormGroup className='mr-4 mb-2'>
                                        <Label>End Date
                                            <Input className='ml-2' type="date"
                                                name="endDate"
                                                onChange={(e) => this.onChange(e, true)}
                                                value={this.props.isFieldNull(this.state.endDate)}
                                            /></Label>
                                    </FormGroup>

                                    <FormGroup className='mr-2 mb-2'>
                                        <Label>Delivery Time (from)
                                            <Input className="ml-2" type="time"
                                                name="deliveryTimeFrom"
                                                onChange={(e) => this.onChange(e)}
                                                value={this.props.isFieldNull(this.state.deliveryTimeFrom)}
                                            /></Label>
                                    </FormGroup>
                                    <FormGroup className='mr-4 mb-2'>
                                        <Label>(until)
                                            <Input className='ml-2' type="time"
                                                name="deliveryTimeUntil"
                                                onChange={(e) => this.onChange(e)}
                                                value={this.props.isFieldNull(this.state.deliveryTimeUntil)}
                                            /></Label>
                                    </FormGroup>
                                </Form>
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col>
                                <Form inline>
                                    <FormGroup className='mr-2 mb-2'>
                                        <Input type="select"
                                            name="selectedTeam"
                                            id="selectedTeam"
                                            onChange={(e) => this.onChange(e, true)}
                                            value={this.props.isFieldNull(this.state.selectedTeam)}
                                        >
                                            <option value="0">ALL TEAMS</option>
                                            {
                                                [...this.state.teams]
                                                    .map(team => (
                                                        <option
                                                            key={"team_" + team.id}
                                                            value={this.props.isFieldNull(team.id)}
                                                        >{team.teamName}</option>
                                                    ))
                                            }
                                        </Input>
                                    </FormGroup>
                                    <FormGroup className='mr-2 mb-2'>
                                        <Input type="select"
                                            name="selectedClient"
                                            id="selectedClient"
                                            onChange={(e) => this.onChange(e, true)}
                                            value={this.props.isFieldNull(this.state.selectedClient)}
                                        >
                                            <option value={0}>ALL CLIENTS</option>
                                            {
                                                [...this.props.clients]
                                                    .map(client => (
                                                        <option
                                                            key={"client_" + client.id}
                                                            value={this.props.isFieldNull(client.id)}
                                                        >{client.client}</option>
                                                    ))
                                            }
                                        </Input>
                                    </FormGroup>
                                    <FormGroup className='mr-2 mb-2'>
                                        <Input type="select"
                                            name="selectedEmployee"
                                            id="selectedEmployee"
                                            onChange={(e) => this.onChange(e, true)}
                                            value={this.props.isFieldNull(this.state.selectedEmployee)}
                                        >
                                            <option value={0}>ALL EMPLOYEES</option>
                                            {
                                                [...this.state.employees]
                                                    .map(employee => (
                                                        <option
                                                            key={"employee_" + employee.employeeId}
                                                            value={this.props.isFieldNull(employee.employeeId)}
                                                        >{employee.lastName + ', ' + employee.firstName}</option>
                                                    ))
                                            }
                                        </Input>
                                    </FormGroup>
                                    <FormGroup className='mr-2 mb-2'>
                                        <Input type="select"
                                            name="selectedWorkflowDuration"
                                            id="selectedWorkflowDuration"
                                            onChange={(e) => this.onChange(e, true)}
                                            value={this.props.isFieldNull(this.state.selectedWorkflowDuration)}
                                        >
                                            <option value={0}>ALL WORKFLOWS</option>
                                            <option value={24}>Daily Workflows</option>
                                            <option value={730}>Monthly Workflows</option>
                                            <option value={2190}>Quarterly Workflows</option>
                                            <option value={8760}>Yearly Workflows</option>
                                        </Input>
                                    </FormGroup>
                                </Form>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form inline>
                                    <FormGroup className='mr-4 mb-2'>
                                        <Label>Highlight&nbsp;<span className="font-weight-bold text-danger">Late</span>
                                            <Input className='ml-2' type="checkbox"
                                                name="highlightLate"
                                                onChange={(e) => this.onChange(e)}
                                                checked={this.state.highlightLate}
                                            /></Label>
                                    </FormGroup>
                                    <FormGroup className='mr-4 mb-2'>
                                        <Label>Highlight&nbsp;<span className="text-primary">Not Completed</span>
                                            <Input className='ml-2' type="checkbox"
                                                name="highlightNotCompleted"
                                                onChange={(e) => this.onChange(e)}
                                                checked={this.state.highlightNotCompleted}
                                            /></Label>
                                    </FormGroup>
                                    <FormGroup className='mr-4 mb-2'>
                                        <Label>Show Workflows
                                            <Input className='ml-2 mr-3' type="radio"
                                                name="show"
                                                value="workflows"
                                                onChange={(e) => this.onChange(e)}
                                                checked={this.props.isFieldNull(this.state.show) === 'workflows'}
                                            /></Label>
                                        <Label>Tasks
                                            <Input className='ml-2 mr-3' type="radio"
                                                name="show"
                                                value="tasks"
                                                onChange={(e) => this.onChange(e)}
                                                checked={this.props.isFieldNull(this.state.show) === 'tasks'}
                                            /></Label>
                                        <Label>Both
                                            <Input className='ml-2 mr-3' type="radio"
                                                name="show"
                                                value="both"
                                                onChange={(e) => this.onChange(e)}
                                                checked={this.props.isFieldNull(this.state.show) === 'both'}
                                            /></Label>
                                    </FormGroup>
                                    {(parseInt(this.state.selectedWorkflowDuration) > 0) && <FormGroup className='mr-4 mb-2'>
                                        <Label>Quick View&nbsp;
                                            <Input className='ml-2' type="checkbox"
                                                name="quickView"
                                                onChange={(e) => this.onChange(e)}
                                                checked={this.state.quickView}
                                            /></Label>
                                    </FormGroup>}
                                    <FormGroup className='mr-4 mb-2'>
                                        <Label>Morning Processes Only&nbsp;
                                            <Input className='ml-2' type="checkbox"
                                                name="morningProcesses"
                                                onChange={(e) => this.onChange(e)}
                                                checked={this.state.morningProcesses}
                                            /></Label>
                                    </FormGroup>
                                </Form>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={2} className=" border-left">
                        <Row className='mt-4 text-right'>
                            <Col className=''>
                                <Input
                                    type="select"
                                    name="autoReload"
                                    value={this.state.autoReload}
                                    onChange={(e) => this.onAutoReload(e.target.value)}
                                >
                                    <option value={0}>No Auto Reload</option>
                                    {/* <option value={5}>5 sec Auto Reload</option> */}
                                    <option value={30}>30 sec Auto Reload</option>
                                    <option value={60}>1 min Auto Reload</option>
                                    <option value={120}>2 min Auto Reload</option>
                                    <option value={300}>5 min Auto Reload</option>
                                    <option value={1800}>30 min Auto Reload</option>
                                    <option value={3600}>1 hour Auto Reload</option>

                                </Input>
                            </Col>
                        </Row>
                        <Progress info={this.props.info} log={this.props.log} autoReloadTime={this.state.autoReloadTime} autoReload={this.state.autoReload} />
                        {this.state.isLoading != null && this.state.isLoading && this.state.isSilent && <Row className='mt-3'>
                            <Col>
                                <h6>Refreshing Data...</h6>
                            </Col>
                        </Row>}
                    </Col>
                </Row>
                {this.state.isLoading != null && (!this.state.isLoading || this.state.isSilent) && <Row className='mt-3'>
                    <Col>
                        <h4>{filteredArray.length} Result{filteredArray.length === 1 ? '' : 's'}</h4>
                    </Col>
                </Row>}
                {this.state.isLoading != null && this.state.isLoading && !this.state.isSilent && <Row className='mt-3'>
                    <Col>
                        <h4>Loading...</h4>
                    </Col>
                </Row>}
                {this.state.isLoading != null && (!this.state.isLoading || this.state.isSilent) && <Table className='mt-3'>
                    <thead>
                        <tr>
                            {this.columns
                                .filter(col =>
                                    (
                                        (this.state.show !== 'tasks' && (col.name === 'Workflow Name' || col.name === 'Workflow Description')) ||
                                        (this.state.show !== 'workflows' && (col.name === 'Workflow Task' || col.name === 'Workflow Task Description')) ||
                                        (col.name !== 'Workflow Name' && col.name !== 'Workflow Description' && col.name !== 'Workflow Task' && col.name !== 'Workflow Task Description')
                                    ) &&
                                    (!this.state.quickView || (parseInt(this.state.selectedWorkflowDuration) === 0 /*&& parseInt(this.state.selectedWorkflowStepDuration) === 0*/) ||
                                        (this.state.quickView && col.quickView === 1) ||
                                        (this.state.quickView && col.quickView === parseInt(this.state.selectedWorkflowDuration)) ||
                                        // (this.state.quickView && col.quickView === parseInt(this.state.selectedWorkflowTaskDuration)) ||
                                        (this.state.quickView && parseInt(this.state.selectedWorkflowDuration) > 24 && col.quickView >= parseInt(this.state.selectedWorkflowDuration)) ||
                                        (this.state.quickView && parseInt(this.state.selectedWorkflowDuration) > 24 && col.quickView >= parseInt(this.state.selectedWorkflowTaskDuration))
                                    )
                                )
                                .map((col) => (
                                    <th key={col.name} onClick={() => this.handleSort(col.index)} className={(col.sort !== false ? 'pointer ' : ' ') /*+ (col.className != null ? col.className : '')*/}>
                                        {col.name}
                                        <span className={"chevron mr-2 " + (col.index === this.state.selectedSortColumnIndex ? "text-info" : "text-white")}><FontAwesomeIcon icon={this.state.selectedSortAscending ? faChevronUp : faChevronDown} /></span>
                                    </th>
                                ))}
                        </tr>
                    </thead>
                    <tbody>
                        {filteredArray.map((row, rowIndex) => {
                            // console.log(row.times)
                            let isLateBool = (row.times != null && typeof (row.times) === 'object') ? (row.deliverableTime < [...row.times].pop().actualEndTime && this.state.highlightLate ? true : false) : false;
                            let isNotEnteredBool = (row.times == null) ? true : false;
                            if (!isLateBool) isLateBool = (row.bdLate > 0) ? true : false;
                            const isLate = (isLateBool || isNotEnteredBool) ? 'font-weight-bold text-danger ' : ' ';
                            let isNotCompleteBool =
                                (row.times != null && row.times.findIndex(time => time.actualStartTime == null || time.actualStartTime === '' || time.actualEndTime == null || time.actualEndTime === '') > -1)
                                    && this.state.highlightNotCompleted ? true : false;
                            if (!isNotCompleteBool) isNotCompleteBool = (row.isComplete === 0) ? true : false;
                            const isNotComplete = isNotCompleteBool ? 'text-primary ' : ' ';
                            const isDueToday = (row.isComplete === 0 && row.businessDayDue === row.date) ? 'activeTabHeader font-weight-bold ' : ' ';
                            return (
                                <Fragment key={rowIndex}>
                                    {row.times != null && row.times.map((time, timeIndex) => (
                                        <Fragment key={rowIndex + "_" + timeIndex}>
                                            {timeIndex === 0 &&
                                                <tr className={isDueToday}>
                                                    <td className={this.isQuickView(0) + isLate + isNotComplete + this.isNull(this.columns[0].className, ' ')}>{row.departments != null && row.departments !== '' ? (row.departments).map(item => item.departmentName).join(', ') : ''}</td>
                                                    <td className={this.isQuickView(1) + isLate + isNotComplete + this.isNull(this.columns[1].className, ' ')}>{row.team}</td>
                                                    <td className={this.isQuickView(2) + isLate + isNotComplete + this.isNull(this.columns[2].className, ' ')}>{row.client}</td>
                                                    {this.state.show !== 'tasks' && <>
                                                        <td className={this.isQuickView(3) + isLate + isNotComplete + this.isNull(this.columns[3].className, ' ')}>{row.workflowName}</td>
                                                        <td className={this.isQuickView(4) + isLate + isNotComplete + this.isNull(this.columns[4].className, ' ')}>{row.workflowDescription}</td>
                                                    </>}
                                                    {this.state.show !== 'workflows' && <>
                                                        <td className={this.isQuickView(5) + isLate + isNotComplete + this.isNull(this.columns[5].className, ' ')}>{row.workflowStep}</td>
                                                        <td className={this.isQuickView(6) + isLate + isNotComplete + this.isNull(this.columns[6].className, ' ')}>{row.workflowStepDescription}</td>
                                                    </>}
                                                    <td className={this.isQuickView(7) + (row.isBackup ? 'font-weight-bold ' : '') + isNotComplete + this.isNull(this.columns[7].className, ' ')}>{row.lastName}, {row.firstName}</td>
                                                    <td className={this.isQuickView(8) + isLate + isNotComplete + this.isNull(this.columns[8].className, ' ')}>{this.formatDate(row.date)}</td>
                                                    <td className={this.isQuickView(9) + isLate + isNotComplete + this.isNull(this.columns[8].className, ' ')}>{row.isComplete ? 'Yes' : ''}</td>
                                                    <td className={this.isQuickView(10) + isLate + isNotComplete + this.isNull(this.columns[9].className, ' ')}>{row.bdCompleted != null && !isNaN(row.bdCompleted) && row.bdCompleted > 0 && row.isComplete === 1 ? Number(row.bdCompleted) : ''}</td>
                                                    <td className={this.isQuickView(11) + isLate + isNotComplete + this.isNull(this.columns[10].className, ' ')}>{row.bdDue != null && !isNaN(row.bdDue) && row.bdDue > 0 ? Number(row.bdDue) /*+' ('+this.formatDate(row.businessDayDue)+')'*/ : ''}</td>
                                                    <td className={this.isQuickView(12) + isLate + isNotComplete + this.isNull(this.columns[11].className, ' ')}>{row.bdLate != null && !isNaN(row.bdLate) && row.bdLate > 0 ? 'Late' : ''}</td>
                                                    <td className={this.isQuickView(13) + isNotComplete + this.isNull(this.columns[12].className, ' ')}>{this.getTime(row.estimatedBeginTime)}</td>
                                                    <td className={this.isQuickView(14) + isLate + isNotComplete + this.isNull(this.columns[13].className, ' ')}>{this.getTime(row.deliverableTime)}</td>
                                                    <td className={this.isQuickView(15) + isNotComplete + this.isNull(this.columns[14].className, ' ')}>{row.targetDuration != null ? row.targetDuration + ' h' : ''}</td>
                                                    <td className={this.isQuickView(16) + isNotComplete + this.isNull(this.columns[15].className, ' ')}>{time.actualStartTimeAdjusted != null && time.actualStartTimeAdjusted !== time.actualStartTime ? <>{this.getTime(time.actualStartTimeAdjusted)} <span className='text-muted font-italic'>{' (' + this.getTime(time.actualStartTime) + ' ' + time.timezone.replace(/[^A-Z]/g, '') + ')'}</span></> : this.getTime(time.actualStartTime)}</td>
                                                    <td className={this.isQuickView(17) + (row.times.length > 1 ? isNotComplete : isLate) + isNotComplete + this.isNull(this.columns[16].className, ' ')}>{time.actualEndTimeAdjusted != null && time.actualEndTimeAdjusted !== time.actualEndTime ? <>{this.getTime(time.actualEndTimeAdjusted)} <span className='text-muted font-italic'>{' (' + this.getTime(time.actualEndTime) + ' ' + time.timezone.replace(/[^A-Z]/g, '') + ')'}</span></> : this.getTime(time.actualEndTime)}</td>
                                                    <td className={this.isQuickView(18) + isNotComplete + this.isNull(this.columns[17].className, ' ')}>{time.actualDuration != null && !isNaN(time.actualDuration) ? Number(time.actualDuration) + ' h' : ''}</td>
                                                    <td className={this.isQuickView(19) + isNotComplete + this.isNull(this.columns[18].className, ' ')}>{row.totalActualDuration != null && !isNaN(row.totalActualDuration) && Number(row.totalActualDuration) !== 0 ? Number(row.totalActualDuration) + ' h' : ''}</td>
                                                    <td className={this.isQuickView(20) + isNotComplete + this.isNull(this.columns[19].className, ' ')}>{row.totalDurationDifference != null && !isNaN(row.totalDurationDifference) ? Number(row.totalDurationDifference) + '%' : ''}</td>
                                                    <td className={this.isQuickView(21) + this.isNull(this.columns[20].className, ' ')}>{time.notes}</td>
                                                    <td >{row.workflowMorningProcess ? "Yes" : "No"}</td>
                                                    <td >{row.workflowStepMorningProcess ? "Yes" : "No"}</td>
                                                </tr>}
                                            {timeIndex > 0 &&
                                                <tr className={"additionalTime " + isDueToday}>
                                                    <td className={this.isQuickView(0) + isNotComplete}></td>
                                                    <td className={this.isQuickView(1) + isNotComplete}></td>
                                                    <td className={this.isQuickView(2) + isNotComplete}></td>
                                                    {this.state.show !== 'tasks' && <>
                                                        <td className={this.isQuickView(3) + isNotComplete}></td>
                                                        <td className={this.isQuickView(4) + isNotComplete}></td>
                                                    </>}
                                                    {this.state.show !== 'workflows' && <>
                                                        <td className={this.isQuickView(5) + isNotComplete}></td>
                                                        <td className={this.isQuickView(6) + isNotComplete}></td>
                                                    </>}
                                                    <td className={this.isQuickView(7) + isNotComplete}></td>
                                                    <td className={this.isQuickView(8) + isNotComplete}></td>
                                                    <td className={this.isQuickView(9) + isNotComplete}></td>
                                                    <td className={this.isQuickView(10) + isNotComplete}></td>
                                                    <td className={this.isQuickView(11) + isNotComplete}></td>
                                                    <td className={this.isQuickView(12) + isNotComplete}></td>
                                                    <td className={this.isQuickView(13) + isNotComplete}></td>
                                                    <td className={this.isQuickView(14) + isNotComplete}></td>
                                                    <td className={this.isQuickView(15) + isNotComplete}></td>
                                                    <td className={this.isQuickView(16) + isNotComplete + this.isNull(this.columns[15].className, ' ')}>{this.getTime(row.times[timeIndex].actualStartTime)}</td>
                                                    <td className={this.isQuickView(17) + (timeIndex === row.times.length - 1 ? isLate + isNotComplete : isNotComplete) + this.isNull(this.columns[16].className, ' ')}>{this.getTime(row.times[timeIndex].actualEndTime)}</td>
                                                    <td className={this.isQuickView(18) + isNotComplete + this.isNull(this.columns[17].className, ' ')}>{Number(row.times[timeIndex].actualDuration)} h</td>
                                                    <td className={this.isQuickView(19)}></td>
                                                    <td className={this.isQuickView(20)}></td>
                                                    <td className={this.isQuickView(21) + + this.isNull(this.columns[20].className, ' ')}>{row.times[timeIndex].notes}</td>
                                                    <td >{row.workflowMorningProcess ? "Yes" : "No"}</td>
                                                    <td >{row.workflowStepMorningProcess ? "Yes" : "No"}</td>
                                                </tr>
                                            }
                                        </Fragment>
                                    ))
                                    }
                                    {row.times == null &&
                                        <Fragment key={rowIndex + "_X"}>
                                            <tr className={isDueToday}>
                                                <td className={this.isQuickView(0) + isLate + isNotComplete + this.isNull(this.columns[0].className, ' ')}></td>
                                                <td className={this.isQuickView(1) + isLate + isNotComplete + this.isNull(this.columns[1].className, ' ')}>{row.team}</td>
                                                <td className={this.isQuickView(2) + isLate + isNotComplete + this.isNull(this.columns[2].className, ' ') + ' font-weight-bold'}>{row.client}</td>
                                                {this.state.show !== 'tasks' && <>
                                                    <td className={this.isQuickView(3) + isLate + isNotComplete + this.isNull(this.columns[3].className, ' ')}>{row.workflowName}</td>
                                                    <td className={this.isQuickView(4) + isLate + isNotComplete + this.isNull(this.columns[4].className, ' ')}>{row.workflowDescription}</td>
                                                </>}
                                                {this.state.show !== 'workflows' && <>
                                                    <td className={this.isQuickView(5) + isLate + isNotComplete + this.isNull(this.columns[5].className, ' ')}>{row.workflowStep}</td>
                                                    <td className={this.isQuickView(6) + isLate + isNotComplete + this.isNull(this.columns[6].className, ' ')}>{row.workflowStepDescription}</td>
                                                </>}
                                                <td className={this.isQuickView(7) + (row.isBackup ? 'font-weight-bold ' : '') + isNotComplete + this.isNull(this.columns[7].className, ' ')}><em>{row.employeePrimaryContact}</em></td>
                                                <td className={this.isQuickView(8) + isLate + isNotComplete + this.isNull(this.columns[8].className, ' ')}>{this.formatDate(row.date)}</td>
                                                <td className={this.isQuickView(9) + isLate + isNotComplete + this.isNull(this.columns[8].className, ' ')}>{row.isComplete ? "Yes" : ""}</td>
                                                <td className={this.isQuickView(10) + isLate + isNotComplete + this.isNull(this.columns[9].className, ' ')}>{row.bdCompleted != null && !isNaN(row.bdCompleted) && row.bdCompleted > 0 && row.isComplete === 1 ? Number(row.bdCompleted) : ''}</td>
                                                <td className={this.isQuickView(11) + isLate + isNotComplete + this.isNull(this.columns[10].className, ' ')}>{row.bdDue != null && !isNaN(row.bdDue) && row.bdDue > 0 ? Number(row.bdDue) /*+' ('+this.formatDate(row.businessDayDue)+')'*/ : ''}</td>
                                                <td className={this.isQuickView(12) + isLate + isNotComplete + this.isNull(this.columns[11].className, ' ')}>{row.bdLate != null && !isNaN(row.bdLate) && row.bdLate > 0 ? 'Late' : ''}</td>
                                                <td className={this.isQuickView(13) + isNotComplete + this.isNull(this.columns[12].className, ' ')}></td>
                                                <td className={this.isQuickView(14) + isLate + isNotComplete + this.isNull(this.columns[13].className, ' ')}>{this.getTime(row.deliverableTime)}</td>
                                                <td className={this.isQuickView(15) + isNotComplete + this.isNull(this.columns[14].className, ' ')}>{row.targetDuration != null ? row.targetDuration + ' h' : ''}</td>
                                                <td className={this.isQuickView(16) + isNotComplete + this.isNull(this.columns[15].className, ' ')}></td>
                                                <td className={this.isQuickView(17) + isNotComplete + this.isNull(this.columns[16].className, ' ')}></td>
                                                <td className={this.isQuickView(18) + isNotComplete + this.isNull(this.columns[17].className, ' ')}></td>
                                                <td className={this.isQuickView(19) + isNotComplete + this.isNull(this.columns[18].className, ' ')}>{row.totalActualDuration != null && !isNaN(row.totalActualDuration) && Number(row.totalActualDuration) !== 0 ? Number(row.totalActualDuration) + ' h' : ''}</td>
                                                <td className={this.isQuickView(20) + isNotComplete + this.isNull(this.columns[19].className, ' ')}>{row.totalDurationDifference != null && !isNaN(row.totalDurationDifference) ? Number(row.totalDurationDifference) + '%' : ''}</td>
                                                <td className={this.isQuickView(21) + this.isNull(this.columns[20].className, ' ')}></td>
                                                <td >{row.workflowMorningProcess ? "Yes" : "No"}</td>
                                                    <td >{row.workflowStepMorningProcess ? "Yes" : "No"}</td>
                                            </tr>
                                        </Fragment>
                                    }
                                </Fragment>
                            )
                        })
                        }
                        <tr className='font-weight-bold'>
                            <td className={this.isQuickView(0)}></td>
                            <td className={this.isQuickView(1)}>Total</td>
                            <td className={this.isQuickView(2)}></td>
                            {this.state.show !== 'tasks' && <>
                                <td className={this.isQuickView(3)}></td>
                                <td className={this.isQuickView(4)}></td>
                            </>}
                            {this.state.show !== 'workflows' && <>
                                <td className={this.isQuickView(5)}></td>
                                <td className={this.isQuickView(6)}></td>
                            </>}
                            <td className={this.isQuickView(7)}></td>
                            <td className={this.isQuickView(8)}></td>
                            <td className={this.isQuickView(9)}></td>
                            <td className={this.isQuickView(10)}></td>
                            <td className={this.isQuickView(11)}></td>
                            <td className={this.isQuickView(12)}></td>
                            <td className={this.isQuickView(13)}></td>
                            <td className={this.isQuickView(14)}></td>
                            <td className={this.isQuickView(15)}>{filteredArray.reduce((prev, next) => prev + next.targetDuration, 0).toFixed(2)} h</td>
                            <td className={this.isQuickView(16)}></td>
                            <td className={this.isQuickView(17)}></td>
                            <td className={this.isQuickView(18)}></td>
                            <td className={this.isQuickView(19)}>{filteredArray.reduce((prev, next) => prev + (next.totalActualDuration != null && !isNaN(next.totalActualDuration) ? Number(next.totalActualDuration) : 0), 0).toFixed(2)} h</td>
                            <td className={this.isQuickView(20)}>{!isNaN(performance) ? performance + '%' : ''}</td>
                            <td className={this.isQuickView(21)}></td>
                        </tr>
                    </tbody>
                </Table>}
            </>
        );

    }
}

export default WorkflowManagement;
